import { json } from 'react-router-dom'
import Axois from '../utils/axios'
import EventEmitter from '../utils/eventEmitter';



export const loadTags = async () => {
  let response = await Axois.get('/tags').catch(err => { throw new Error('Could not fetch data!\nPlease check your network connectivity!') })
    const responseData = await response.data;
    return responseData;
  // return [];
}


export const loadTag = async (action) => {
  try {
    switch (action) {
      case 'new':
        // let requests = await Axois.get('/setups/tags');
        // const responseData = await requests.data;
        // return {...responseData, tag: {}};
        return { };
      
      default:
        let response = await Axois.get('/tags/'+action);
        const responseJson = await response.data;
        return responseJson;
        // return { positions: [], budgets: [], tag: {}};
    }
  }catch (err) {
    console.log(err);
  }
}



const useTagAPI = () => {
  
  const save = async (data, success) => {
    try {
      const response = await Axois.post('/tags', data);
      const responseData = await response.data;
      success(responseData.message);
      EventEmitter.dispatch('tag_response', data.seo);
    }catch(err) {
      console.log(err);
    }
  };


  const update = async (seo, data, success) => {
    try {
      const response = await Axois.put('/tags/'+seo, data);
      const responseData = await response.data;
      success(responseData.message);
      EventEmitter.dispatch('tag_response', data.seo);
    }catch (err) {
      console.log(err);
    }
  }

  return { save, update };
}


export default useTagAPI;